/* eslint-disable @typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';

xplenty.controller('ComponentEditorRestApiSourceController', [
  '$scope',
  '$rootScope',
  '$translate',
  '$controller',
  '$timeout',

  function ($scope, $rootScope, $translate, $controller, $timeout) {
    $scope.selectedFields = _.clone($scope.component.schema.fields);
    let componentNameValid = false;

    angular.extend(this, $controller('AuthenticationStep', { $scope }));
    angular.extend(this, $controller('ComponentFormStep', { $scope }));
    angular.extend(this, $controller('SchemaImporterStep', { $scope }));

    const checkValidity = function () {
      $scope.$parent.saveDisabled =
        !$scope.authenticationStep.valid ||
        !$scope.componentFormStep.valid ||
        !$scope.schemaImporterStep.valid ||
        !componentNameValid ||
        !$scope.headersValid;

      $rootScope.$broadcast(
        EVENTS.DATA_PREVIEW_DISABLED,
        !($scope.authenticationStep.valid && $scope.componentFormStep.valid),
      );
    };

    $scope.$watch(
      '[component, headersValid]',
      function () {
        $timeout(function () {
          $scope.componentFormStep.validate(!$scope.headersValid);
          $scope.schemaImporterStep.validate();
          $timeout(checkValidity);
        });
      },
      true,
    );

    $scope.$watch(
      'schemaImporterStep',
      function (newSchemaImporterStep, oldSchemaImporterStep) {
        if (
          newSchemaImporterStep.active &&
          !oldSchemaImporterStep.active &&
          $scope.authenticationStep.valid &&
          $scope.componentFormStep.valid
        ) {
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_GET_SCHEMA, $scope.component.disableSchemaLoad);
        }
        if (newSchemaImporterStep.active && !oldSchemaImporterStep.active) {
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_REFRESH);
        }
        checkValidity();
        $scope.schemaImporterStep.validate();
      },
      true,
    );

    $scope.authenticationStep.active = true;

    $timeout(function () {
      $scope.schemaImporterStep.validate();
    }, 10);

    $scope.$on(EVENTS.DESIGNER_COMPONENT_NAME_VALID, function (event, valid) {
      componentNameValid = valid;
    });
  },
]);
